import SessionStorage from '../services/session-storage';

export const getBaseUrl = () => {
    const config = SessionStorage.getItem('config', {});

    if (!config) {
        console.error('No config found');
    }

    return `${config.PROXY_API_BASE_URL}api/v1`;
};

export const getApiScope = () => {
    const { PROXY_API_CLIENT_ID } = SessionStorage.getItem('config', {});

    if (!PROXY_API_CLIENT_ID) {
        console.error('No PROXY_API_CLIENT_ID CLIENT ID found');
    }

    const scopes = [`${PROXY_API_CLIENT_ID}/ReadStatus`];    

    return { scopes };
};

export const getDataExplorerApiScope = () => {
    const scopes = [`https://help.kusto.windows.net/user_impersonation`];    

    return { scopes };
};

